var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('v-img',{attrs:{"src":require("@/assets/images/no_data_found.png"),"lazy-src":require("@/assets/images/no_data_found.png"),"height":"75%","width":"75%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }